module.exports = __webpack_public_path__ + "static/3-0305b6048b8c18bb00d4683b33ab0fbf.jpg";